import React from "react";
import "../Sidebar/sidebar.css";
import { Link } from "react-router-dom";
import opptimiseLogo from "../../../images/new-images/Brand-Logo.png";

const Rendersidebar = (props) => {
  const userType = localStorage.getItem("usertype");
  const addActiveClassName = (sideBarItem) => {
    return props.selectedSideNav === sideBarItem ? "active" : "";
  };

  return (
    <nav className="sidenav">
      {!userType.includes("organisation_admin") && !userType.includes("seller_admin") && (
        <Link to="/new/app/dashBoard">
          <img src={opptimiseLogo} alt="Opptimise Logo" />
        </Link>
      )}

      <ul>
        {props.items.map((sideBarItem, index) => {
          const isAnalysis = sideBarItem.id === "analysis";
          const linkStyle = isAnalysis ? {
            backgroundColor: "#fff",
            cursor: "not-allowed",
            opacity: "0.4",
          } : {};

          return (
            <React.Fragment key={index}>
              <li>
                <Link 
                  to={sideBarItem.link || "#"} 
                  className={addActiveClassName(sideBarItem.id)}
                  style={linkStyle}
                >
                  <img
                    src={
                      props.selectedSideNav === sideBarItem.id
                        ? sideBarItem.navLightImage
                        : sideBarItem.navImage
                    }
                    alt="nav-image"
                    style={{ opacity: isAnalysis ? 0.4 : 1 }}
                  />
                  <div className="arrow-symbol"></div>
                  <span>{sideBarItem.linkName}</span>
                </Link>
              </li>
              <hr />
            </React.Fragment>
          );
        })}
      </ul>
    </nav>
  );
};

export default Rendersidebar;


// WEBPACK FOOTER //
// ./src/new/Components/Sidebar/sidebar.jsx